// src/utils/errors.js

/**
 * Base API error class with type classification
 */
export class APIError extends Error {
  constructor(message, status, type, data = null) {
    super(message);
    this.name = 'APIError';
    this.status = status;
    this.type = type; // 'network', 'timeout', 'auth', 'server', 'client'
    this.data = data;
    this.timestamp = new Date().toISOString();
  }

  isRetryable() {
    return this.type === 'network' || 
           this.type === 'timeout' || 
           (this.status >= 500 && this.status < 600);
  }

  isAuthError() {
    return this.status === 401 || this.status === 403;
  }

  toJSON() {
    return {
      name: this.name,
      message: this.message,
      status: this.status,
      type: this.type,
      data: this.data,
      timestamp: this.timestamp
    };
  }
}

/**
 * Timeout error - request exceeded time limit
 */
export class TimeoutError extends APIError {
  constructor(message, timeout) {
    super(message, 408, 'timeout');
    this.name = 'TimeoutError';
    this.timeout = timeout;
  }
}

/**
 * Network error - fetch failed (connection issue)
 */
export class NetworkError extends APIError {
  constructor(message, originalError = null) {
    super(message, 0, 'network');
    this.name = 'NetworkError';
    this.originalError = originalError;
  }
}

/**
 * Authentication error - 401/403 responses
 */
export class AuthenticationError extends APIError {
  constructor(message, status, data = null) {
    super(message, status, 'auth', data);
    this.name = 'AuthenticationError';
  }
}

/**
 * Server error - 5xx responses
 */
export class ServerError extends APIError {
  constructor(message, status, data = null) {
    super(message, status, 'server', data);
    this.name = 'ServerError';
  }
}

/**
 * Client error - 4xx responses (except 401/403)
 */
export class ClientError extends APIError {
  constructor(message, status, data = null) {
    super(message, status, 'client', data);
    this.name = 'ClientError';
  }
}
